// Generated by ReScript, PLEASE EDIT WITH CARE


function getPaymentMode(val) {
  switch (val) {
    case "applePay" :
      return "ApplePayElement";
    case "card" :
      return "Card";
    case "cardCvc" :
      return "CardCVCElement";
    case "cardExpiry" :
      return "CardExpiryElement";
    case "cardNumber" :
      return "CardNumberElement";
    case "expressCheckout" :
      return "ExpressCheckoutElement";
    case "googlePay" :
      return "GooglePayElement";
    case "klarna" :
      return "KlarnaElement";
    case "payPal" :
      return "PayPalElement";
    case "payment" :
      return "Payment";
    case "paymentMethodCollect" :
      return "PaymentMethodCollectElement";
    case "paymentMethodsManagement" :
      return "PaymentMethodsManagement";
    case "paze" :
      return "PazeElement";
    case "samsungPay" :
      return "SamsungPayElement";
    default:
      return "NONE";
  }
}

function getPaymentModeToString(val) {
  switch (val) {
    case "Card" :
      return "card";
    case "Payment" :
      return "payment";
    case "CardNumberElement" :
      return "cardNumber";
    case "CardExpiryElement" :
      return "cardExpiry";
    case "CardCVCElement" :
      return "cardCvc";
    case "PaymentMethodCollectElement" :
      return "paymentMethodCollect";
    case "GooglePayElement" :
      return "googlePay";
    case "PayPalElement" :
      return "payPal";
    case "ApplePayElement" :
      return "applePay";
    case "SamsungPayElement" :
      return "samsungPay";
    case "KlarnaElement" :
      return "klarna";
    case "PazeElement" :
      return "paze";
    case "ExpressCheckoutElement" :
      return "expressCheckout";
    case "PaymentMethodsManagement" :
      return "paymentMethodsManagement";
    case "NONE" :
      return "none";
  }
}

function getPaymentModeToStrMapper(val) {
  return val;
}

export {
  getPaymentMode,
  getPaymentModeToString,
  getPaymentModeToStrMapper,
}
/* No side effect */
